<template>
  <div style="background: #fff">
    <div class="header">
      <div class="logo-img">
        <img src="../../assets/img/logo.png" @click="onHome" alt="" />
      </div>
      <div class="headRight">
        <h3 v-if="title" class="head-title">{{ title }}</h3>
        <el-divider direction="vertical" />
        <a href="/"><i class="el-icon-s-home" />  首页</a>
        <el-divider direction="vertical" />
        <a @click.stop.prevent="onBack()"><i class="el-icon-back" />  返回</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Welcome: '',
    }
  },
  props: {
    title: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    onHome() {
      if (this.$route.path !== '/') {
        window.location.href = "/"
      }
    },
    onBack() {
      window.history.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.head-title {
  font-size: 16px;
  color: #000;
  font-weight: 600;
  margin-right: 20px;
}
.header {
  width: 1226px;
  margin: 0 auto;
  padding: 3px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo-img {
    height: 60px;
    img {
      height: 100%;
    }
  }

  .headRight {
    display: flex;
    align-items: center;
    color: #5c5c5c;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 600;
    padding-right: 10px;
  }
}
</style>